/**
 * sessionLog — noise-controlled logger for session-manager internals.
 *
 * Debug output is off by default in production builds. Turn it on for one
 * tab by running `window.__BB_SESSION_DEBUG__ = true` in devtools, or
 * enable everywhere by rebuilding with import.meta.env.DEV truthy.
 *
 * console.warn / console.error are NOT gated — those keep flowing so
 * real failures still surface.
 */

const isDebug = () => {
  if (typeof window !== 'undefined' && window.__BB_SESSION_DEBUG__) return true;
  try {
    // Vite dev builds set import.meta.env.DEV to true. Guarded because
    // Jest/CJS callers don't have import.meta.
    // biome-ignore lint/style/useNamingConvention: legacy env const
    return typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.DEV === true;
  } catch {
    return false;
  }
};

export const sessionLog = (...args) => {
  if (isDebug()) console.log(...args);
};

sessionLog.warn = (...args) => console.warn(...args);
sessionLog.error = (...args) => console.error(...args);
